export class User {
  constructor({
    uid = null,
    employeeId = null,
    checkInLocations = [],
    checkOutLocations = [],
    isManager = null,
    companyId = null,
    partnerId = null,
    userName = null,
    jobTitle = null,
    jobPosition = null,
    partnerImg = null,
    accessToken = null,
    refreshToken = null,
    expiresIn = null,
    tokenType = null,
    odooSessionId = null,
    companyName = null,
    db = null,
    attendanceLocations = [],
    fcmToken = null,
    hasAttendanceService = true,
    hasLeaveService = true,
    hasExpenseService = true,
    hasApprovalService = true,
    hasTimesheetService = true,
  } = {}) {
    this.uid = uid;
    this.employeeId = employeeId;
    this.checkInLocations = checkInLocations;
    this.checkOutLocations = checkOutLocations;
    this.isManager = isManager;
    this.companyId = companyId;
    this.partnerId = partnerId;
    this.userName = userName;
    this.jobTitle = jobTitle;
    this.jobPosition = jobPosition;
    this.partnerImg = partnerImg;
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    this.expiresIn = expiresIn;
    this.tokenType = tokenType;
    this.odooSessionId = odooSessionId;
    this.companyName = companyName;
    this.db = db;
    this.attendanceLocations = attendanceLocations;
    this.fcmToken = fcmToken;
    this.hasAttendanceService = hasAttendanceService;
    this.hasLeaveService = hasLeaveService;
    this.hasExpenseService = hasExpenseService;
    this.hasApprovalService = hasApprovalService;
    this.hasTimesheetService = hasTimesheetService;
  }

  static fromJson(json = {}) {
    return new User({
      uid: json.uid ?? json.id ?? null,
      employeeId: json.employeeId ?? json.employee_id ?? null,
      checkInLocations: Array.isArray(json.checkInLocations)
        ? json.checkInLocations
        : Array.isArray(json.check_in_locations)
          ? json.check_in_locations
          : [],
      checkOutLocations: Array.isArray(json.checkOutLocations)
        ? json.checkOutLocations
        : Array.isArray(json.check_out_locations)
          ? json.check_out_locations
          : [],
      isManager: json.isManager ?? json.is_manager ?? null,
      companyId: json.companyId ?? json.company_id ?? null,
      partnerId: json.partnerId ?? json.partner_id ?? null,
      userName: json.userName ?? json.user_name ?? json.name ?? null,
      jobTitle: json.jobTitle ?? json.job_title ?? null,
      jobPosition: json.jobPosition ?? json.job_position ?? null,
      partnerImg: json.partnerImg ?? json.partner_img ?? null,
      accessToken: json.accessToken ?? json.access_token ?? null,
      refreshToken: json.refreshToken ?? json.refresh_token ?? null,
      expiresIn: json.expiresIn ?? json.expires_in ?? null,
      tokenType: json.tokenType ?? json.token_type ?? null,
      odooSessionId: json.odooSessionId ?? json.odoo_session_id ?? null,
      companyName: json.companyName ?? json.company_name ?? null,
      db: json.db ?? json.database ?? null,
      attendanceLocations: Array.isArray(json.attendanceLocations)
        ? json.attendanceLocations
        : Array.isArray(json.attendance_locations)
          ? json.attendance_locations
          : [],
      fcmToken: json.fcmToken ?? json.mob_token ?? null,
      hasAttendanceService: json.hasAttendanceService ?? json.has_attendance_service ?? true,
      hasLeaveService: json.hasLeaveService ?? json.has_leave_service ?? true,
      hasExpenseService: json.hasExpenseService ?? json.has_expense_service ?? true,
      hasApprovalService: json.hasApprovalService ?? json.has_approval_service ?? true,
      hasTimesheetService: json.hasTimesheetService ?? json.has_timesheet_service ?? true,
    });
  }

  toJson() {
    return {
      id: this.uid,
      employee_id: this.employeeId,
      check_in_locations: this.checkInLocations,
      check_out_locations: this.checkOutLocations,
      is_manager: this.isManager,
      company_id: this.companyId,
      partner_id: this.partnerId,
      user_name: this.userName,
      job_title: this.jobTitle,
      job_position: this.jobPosition,
      partner_img: this.partnerImg,
      company_name: this.companyName,
      db: this.db,
      mob_token: this.fcmToken,
      attendance_locations: this.attendanceLocations,
      has_attendance_service: this.hasAttendanceService,
      has_leave_service: this.hasLeaveService,
      has_expense_service: this.hasExpenseService,
      has_approval_service: this.hasApprovalService,
      has_timesheet_service: this.hasTimesheetService,
      access_token: this.accessToken,
      refresh_token: this.refreshToken,
      expires_in: this.expiresIn,
      token_type: this.tokenType,
      odoo_session_id: this.odooSessionId,
    };
  }
}
